// extracted by mini-css-extract-plugin
module.exports = {"item":"_a521071b","favorites":"_485f0a49","favoritesWrapper":"_c513d99a","favoritesIconWrapper":"_b6cdc0b1"};